/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/
import {Component, Input, ChangeDetectionStrategy} from '@angular/core';
import {SelectInTableDropdownShipToPartiesModel} from '../../../../shared/select-in-table/select-in-table-dropdown/models/select-in-table-dropdown-ship-to-parties.model';

@Component({
    selector: 'app-technician-groups-tooltip-content',
    templateUrl: './technician-groups-tooltip-content.component.html',
    styleUrls: [],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TechnicianGroupsTooltipContentComponent {
    @Input() name: string;
    @Input() description: string;

    descriptionShipToParties(description: string): string[] {
        let descriptionValue;

        try {
            descriptionValue = JSON.parse(description);
        } catch {
        }

        return descriptionValue?.shipToParties
                ?.map((stp: SelectInTableDropdownShipToPartiesModel) => `${stp.code} ${stp.name}`);
    }

    descriptionModelCodes(description: string): string {
        let descriptionValue;

        try {
            descriptionValue = JSON.parse(description);
        } catch {
        }

        return descriptionValue?.modelCodes?.join(', ');
    }
}
